import {Feature} from 'acng/core/model/feature';

const name = 'comment';
export default name;
export const commentFeature = new Feature(name);
